import React, { useState, useEffect } from "react";
import moment from "moment";
import { injectIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
//controls
import { Container } from "@mui/material";
import Table from "./components/table";
import useExport from "Components/Table/Export";
import { NotificationManager } from "Components/Notifications";
import { defaultLocale } from 'Core/defaultValues';
//actions
import {
  searchLoginHistory,
  showSidePanelFilter,
  clearRedux,
} from "Redux/actions";

const ROWS_PER_PAGE = 25;

const LoginHistoryView = (props) => {
  // Props
  const {
    intl: { messages },
  } = props;

  // Hooks
  const dispatch = useDispatch();

  // State manager
  const { loading, registers, allfilters, nextToken, error } = useSelector(
    (state) => state.loginHistoryRedux
  );

  // State manager
  const { user } = useSelector(
    (state) => state.securityRedux
  );

  // Local state
  const [filters, setFilters] = useState({
    ...allfilters,
    limit: ROWS_PER_PAGE,
    resetSearch: true,
  });

  const [startDate, setStartDate] = useState(allfilters.dateRange.start);
  const [endDate, setEndDate] = useState(allfilters.dateRange.end);
  const [beforeRangeDate, setBeforeRangeDate] = useState({
    start: allfilters.dateRange.start,
    end: endDate,
  });

  useEffect(() => {
    if (error) {
      NotificationManager.error(
        messages["errorMessage"],
        messages["error"],
        3000,
        null,
        null,
        "warning"
      );
      dispatch(clearRedux("LOGIN_HISTORY", { error: false }));
    }
  }, [error]);

  useEffect(() => {
    return () => {
      dispatch(clearRedux("LOGIN_HISTORY"));
    }
  }, []);

  const getHeaders = () => {
    return [
      messages["loginHistoryView_loginTime"],
      messages["loginHistoryView_username"],
      messages["loginHistoryView_ip"],
      messages["loginHistoryView_attempt"],
    ];
  };

  const getDataToExport = (rows) => {
    let data = [];
    rows.forEach((item) => {
      let createdOn = moment
        .unix(item.createdOn)
        .locale(defaultLocale || "en")
        .format("DD/MM/YYYY hh:mm A");
      let attempt;
      switch (item.attemptResult) {
        case "SUCCESSFUL_LOGIN":
          attempt = "Successful";
          break;
        default:
          attempt = "Failed";
          break;
      }
      data.push([createdOn, item.username, item.ip, attempt]);
    });

    return data;
  };

  // Use hook to export PDF
  const exportCSVPdf = useExport(
    getHeaders,
    getDataToExport,
    null,
    registers,
    null,
    messages["loginHistoryView_login"],
    null,
    true
  );

  //Validate is PDF of CSV export
  const onExport = (type) => {
    if (type === "CSV") {
      exportCSVPdf.exportCSV();
    } else if (type === "PDF") {
      exportCSVPdf.exportPDF();
    }
  };

  const onChangeStartEndDate = ({ start, end }) => {
    const newStart = start && new Date(start);
    const newEnd = end && new Date(end);

    // Set New Date Range
    setStartDate(newStart);
    setEndDate(newEnd);

    if (start && end) {
      //Time is added to take the full range of the day
      end.setHours(24);

      const newDateRange = {
        start,
        end,
      };

      setBeforeRangeDate(newDateRange);
      setFilters({
        ...filters,
        dateRange: newDateRange
      })
      
      dispatch(
        searchLoginHistory({
          ...filters,
          dateRange: newDateRange,
          resetSearch: true,
          nextToken: null,
        })
      );
    }
  };

  const onChangeDate = (value) => {
    // On change Date
    const { start, end } = value;
    onChangeStartEndDate({
      start,
      end,
    });
  };

  const onCloseSelectDate = () => {
    const { start, end } = beforeRangeDate;
    if (start && end && !endDate) {
      setStartDate(start);
      setEndDate(end);
    }
  };

  return (
    <Container maxWidth={false} style={{ height: '100%', paddingBottom: 80 }}>
      <Table
        loading={loading}
        data={registers}
        messages={messages}
        user={user}
        onSearch={(text) => {
          let filterResult = {
            ...filters,
            openSearch: text,
            resetSearch: true,
            nextToken: null,
          };
          dispatch(searchLoginHistory(filterResult));
          setFilters(filterResult);
        }}
        onChangePage={() => {
          let newFilter = {
            ...filters,
            resetSearch: !nextToken,
            nextToken,
          };
          dispatch(searchLoginHistory(newFilter));
        }}
        showSidePanelFilter={() => dispatch(showSidePanelFilter())}
        onExport={onExport}
        nextToken={nextToken}
        startDate={startDate}
        endDate={endDate}
        onChangeDate={onChangeDate}
        onCloseSelectDate={onCloseSelectDate}
      />
    </Container>
  );
};

export default injectIntl(LoginHistoryView);
